import { version as configVersion } from 'Config'

const VERSION_PLACEHOLDER = '{version}'

/**
 * Resolves the `{version}` placeholder in `urls.logoFull` - every `config.<env>.json` uses it.
 * `version` is bumped on the release branch, and it is the same segment the deploy workflows
 * use for the CDN prefix, so the logo resolves to `<env>/<version>/assets/`.
 *
 * Returns `undefined` when the template still needs a version and none is available, so
 * `useDynamicLogo` keeps the bundled logo instead of requesting a literal `{version}` URL.
 */
const resolveLogoUrl = (configuredUrl, version = configVersion) => {
  if (!configuredUrl) {
    return undefined
  }

  if (!configuredUrl.includes(VERSION_PLACEHOLDER)) {
    return configuredUrl
  }

  if (!version) {
    return undefined
  }

  return configuredUrl.split(VERSION_PLACEHOLDER).join(version)
}

export default resolveLogoUrl
